import React from "react";
import "./Plans.css";

export default function Plans() {
  return (
    <div className="Plans" id="plans">
      <header>
        <h2>Plans</h2>
        <h3>
          All my plans will be designed to your personal needs and lifestyle, to
          get you from where you are to where you want to be.
        </h3>
        <p>
          Either you want to workout at home, at the gym or outdoors, we can
          work together no matter what. With your subscription you will receive
          a personalised diet plan and a training program, which we will talk
          through every week to make sure it fits you. With both, you will be
          able to improve not only your nutrition and your fitness but your life
          as well. In every session we will talk about your achievements,
          changing of goals, how well are you adapting, any changes we can make,
          how are you feeling about the plans, changes on your routine, etc...
          Everything you need to achieve your goals.
        </p>
      </header>
      <main>
        <div className="row row-1">
          <div className="container">
            <h4>1st consultation</h4>
            <h5>Free</h5>
            <hr />
            <ul>
              <li>Free consultation</li>
              <li>Meeting before commiting</li>
              <li>How to meet your goals</li>
            </ul>
            <a href="#contact">
              <button>Get in touch!</button>
            </a>
          </div>
          <div className="container">
            <h4>Monthly</h4>
            <h5>£200</h5>
            <hr />
            <ul>
              <li>1st consultation free</li>
              <li>Weekly Check-ins</li>
              <li>No commitment</li>
            </ul>
            <a
              href="https://buy.stripe.com/00gdUg3DOfIa06YbIJ"
              rel="noreferrer"
              target="_blank"
            >
              <button>Let's go!</button>
            </a>
          </div>
        </div>
        <div className="row">
          <div className="container">
            <h4>3 months</h4>
            <h5>£158</h5>
            <p>per month</p>
            <hr />
            <ul>
              <li>1st consultation free</li>
              <li>Weekly Check-ins</li>
              <li>3 months commitment</li>
              <li>£475 pay in one go</li>
            </ul>
            <a
              href="https://buy.stripe.com/cN26rO5LWgMebPG8wz"
              rel="noreferrer"
              target="_blank"
            >
              <button>Let's go!</button>
            </a>
          </div>
          <div className="container">
            <h4>6 months</h4>
            <h5>£130</h5>
            <p>per month</p>
            <hr />
            <ul>
              <li>1st consultation free</li>
              <li>Weekly Check-ins</li>
              <li>6 months commitment</li>
              <li>£780 pay in one go</li>
            </ul>
            <a
              href="https://buy.stripe.com/7sI2by2zKbrU8Du004"
              rel="noreferrer"
              target="_blank"
            >
              <button>Let's go!</button>
            </a>
          </div>
        </div>
      </main>
    </div>
  );
}
